/* INKora - DTF Gang Sheet Upload (product.dtf-upload)
 * The customer uploads a finished gang sheet (PNG / PDF / AI). We read its size from the file header, pick the
 * matching length (1-30 ft, all sheets 13 in wide), show the price and add it to the cart. The file travels as the
 * hidden line-item property "_Artwork File" (Shopify native upload, 20 MB); bigger files use the "Artwork Link" field. */
(function () {
  'use strict';
  var root = document.querySelector('[data-dtfu-root]');
  if (!root) return;
  var cfgEl = root.querySelector('[data-dtfu-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var variants = (cfg.variants || []).slice().sort(function (a, b) { return a.feet - b.feet; });
  var MAX_BYTES = (cfg.maxFileMb || 20) * 1024 * 1024;
  var WIDTH = cfg.widthIn || 13;
  var TOL = 0.15; // inches of tolerance on the 13" width and when rounding the length up

  function q(s) { return root.querySelector(s); }
  var els = {
    drop: q('[data-dtfu-drop]'), input: q('[data-dtfu-input]'), error: q('[data-dtfu-error]'),
    file: q('[data-dtfu-file]'), thumb: q('[data-dtfu-thumb]'), name: q('[data-dtfu-name]'), size: q('[data-dtfu-size]'),
    remove: q('[data-dtfu-remove]'), detect: q('[data-dtfu-detect]'), note: q('[data-dtfu-note]'),
    linkRow: q('[data-dtfu-linkrow]'), link: q('[data-dtfu-link]'),
    sumSize: q('[data-dtfu-sumsize]'), sumPrice: q('[data-dtfu-sumprice]'), sumTotal: q('[data-dtfu-sumtotal]'), sumEach: q('[data-dtfu-sumeach]'),
    qty: q('[data-dtfu-qty]'), qtyLabel: q('[data-dtfu-qtylabel]'), minus: q('[data-dtfu-minus]'), plus: q('[data-dtfu-plus]'),
    add: q('[data-dtfu-add]'), addErr: q('[data-dtfu-adderr]'), table: q('[data-dtfu-table]')
  };

  var state = { file: null, big: false, url: '', detected: null, variant: null, autoPicked: false, mode: 'sheet', design: null };

  function money(c) {
    var v = (c / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function mb(n) { return (n / 1048576).toFixed(n > 10485760 ? 0 : 1) + ' MB'; }
  function round1(n) { return Math.round(n * 10) / 10; }

  function setError(msg) {
    els.error.textContent = msg || '';
    els.error.hidden = !msg;
  }

  // ---------- read the print size from the file header ----------
  function readSlice(file, start, end) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () { resolve(fr.result); };
      fr.onerror = function () { reject(fr.error); };
      fr.readAsArrayBuffer(file.slice(start, Math.min(end, file.size)));
    });
  }

  function readPng(file) {
    return readSlice(file, 0, 131072).then(function (buf) {
      var dv = new DataView(buf);
      var sig = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
      for (var i = 0; i < 8; i++) if (dv.getUint8(i) !== sig[i]) return null;
      var w = dv.getUint32(16), h = dv.getUint32(20);
      var dpi = null, pos = 8;
      while (pos + 8 <= buf.byteLength) {
        var len = dv.getUint32(pos);
        var type = String.fromCharCode(dv.getUint8(pos + 4), dv.getUint8(pos + 5), dv.getUint8(pos + 6), dv.getUint8(pos + 7));
        if (type === 'pHYs' && pos + 17 <= buf.byteLength) {
          var ppx = dv.getUint32(pos + 8), ppy = dv.getUint32(pos + 12), unit = dv.getUint8(pos + 16);
          if (unit === 1 && ppx > 0 && ppy > 0) dpi = { x: ppx * 0.0254, y: ppy * 0.0254 };
        }
        if (type === 'IDAT' || type === 'IEND') break;
        pos += 12 + len;
      }
      return { kind: 'png', px: { w: w, h: h }, dpi: dpi };
    });
  }

  function readPdfLike(file) {
    var head = readSlice(file, 0, 4 * 1048576);
    var tail = file.size > 4 * 1048576 ? readSlice(file, file.size - 4 * 1048576, file.size) : Promise.resolve(null);
    return Promise.all([head, tail]).then(function (parts) {
      var dec = new TextDecoder('latin1');
      var text = dec.decode(parts[0]) + (parts[1] ? '\n' + dec.decode(parts[1]) : '');
      var unit = 1;
      var uu = /\/UserUnit\s+([\d.]+)/.exec(text);
      if (uu) unit = parseFloat(uu[1]) || 1;
      var re = /\/MediaBox\s*\[\s*(-?[\d.]+)\s+(-?[\d.]+)\s+(-?[\d.]+)\s+(-?[\d.]+)\s*\]/g, m, best = null;
      while ((m = re.exec(text))) {
        var w = Math.abs(parseFloat(m[3]) - parseFloat(m[1])), h = Math.abs(parseFloat(m[4]) - parseFloat(m[2]));
        if (w > 1 && h > 1) { best = { w: w, h: h }; break; }
      }
      if (!best) {
        var bb = /%%(?:HiRes)?BoundingBox:\s*(-?[\d.]+)\s+(-?[\d.]+)\s+(-?[\d.]+)\s+(-?[\d.]+)/.exec(text);
        if (bb) {
          var bw = Math.abs(parseFloat(bb[3]) - parseFloat(bb[1])), bh = Math.abs(parseFloat(bb[4]) - parseFloat(bb[2]));
          if (bw > 1 && bh > 1) best = { w: bw, h: bh };
        }
      }
      if (!best) return null;
      if (/\/Rotate\s+(90|270)\b/.test(text)) best = { w: best.h, h: best.w };
      return { kind: 'pdf', inches: { w: best.w * unit / 72, h: best.h * unit / 72 } };
    });
  }

  // returns { w, h, note } in inches (w = the 13" side) or null when the size could not be read
  function sizeFromInfo(info) {
    if (!info) return null;
    var a, b, note = '';
    if (info.kind === 'png') {
      var dpx = info.dpi ? info.dpi.x : null;
      var dpy = info.dpi ? info.dpi.y : null;
      var cand = [];
      if (dpx && dpy) cand.push({ x: dpx, y: dpy, src: 'file' });
      [300, 200, 150, 100, 72].forEach(function (d) { cand.push({ x: d, y: d, src: 'guess' }); });
      var pick = null;
      for (var i = 0; i < cand.length && !pick; i++) {
        var iw = info.px.w / cand[i].x, ih = info.px.h / cand[i].y;
        var mn = Math.min(iw, ih), mx = Math.max(iw, ih);
        // a real gang sheet has its narrow side at most 13 in
        if (mn <= WIDTH + TOL && mn >= 5) pick = { a: iw, b: ih, src: cand[i].src, dpi: cand[i].x };
      }
      if (!pick) {
        // nothing fits 13 in: report it at the declared (or 300) dpi so the "too wide" message is accurate
        var d0 = cand[0].x, d1 = cand[0].y;
        pick = { a: info.px.w / d0, b: info.px.h / d1, src: cand[0].src, dpi: d0 };
      }
      a = pick.a; b = pick.b;
      if (pick.src === 'guess') note = (info.dpi ? 'The print size saved in this PNG does not match a 13" sheet, so we assumed ' : 'This PNG does not say its print size, so we assumed ') + pick.dpi + ' dpi.';
      else note = '';
      info._dpi = pick.dpi;
    } else {
      a = info.inches.w; b = info.inches.h;
    }
    var width, length;
    var aOk = a <= WIDTH + TOL, bOk = b <= WIDTH + TOL;
    if (aOk && bOk) { width = Math.max(a, b); length = Math.min(a, b); }
    else if (aOk) { width = a; length = b; }
    else if (bOk) { width = b; length = a; }
    else { width = Math.min(a, b); length = Math.max(a, b); }
    return { w: width, h: length, note: note, dpi: info._dpi || null };
  }

  function pickVariant(lengthIn) {
    var needFeet = Math.ceil(lengthIn / 12 - TOL / 12);
    if (needFeet < 1) needFeet = 1;
    for (var i = 0; i < variants.length; i++) if (variants[i].feet >= needFeet) return variants[i];
    return null;
  }

  // ---------- UI ----------
  function currentVariant() { return state.variant; }

  // ---------- single design + copies: how many fit on the 13" sheet, how long a sheet we need ----------
  var GAP = 0.25, FIT_TOL = 0.1, MAX_COPIES = 99999, MAX_SHEETS = 99;
  function fitCols(w) { return Math.floor((WIDTH + GAP + FIT_TOL) / (w + GAP)); }
  function rowsPerSheet(h, feet) { return Math.floor((feet * 12 + GAP + FIT_TOL) / (h + GAP)); }
  function packPlan(dw, dh, copies) {
    var best = null, v30 = variants[variants.length - 1];
    [[dw, dh], [dh, dw]].forEach(function (o) {
      var w = o[0], h = o[1], cols = fitCols(w);
      if (cols < 1) return;
      var rows = Math.ceil(copies / cols);
      // one continuous print: full 30 ft lengths plus the smallest length that covers the rest
      var len = rows * h + (rows - 1) * GAP;
      var n30 = Math.floor((len + FIT_TOL) / (v30.feet * 12)), rem = len - n30 * v30.feet * 12, lines = [];
      if (n30 > 0) lines.push({ v: v30, qty: n30 });
      if (rem > FIT_TOL) {
        for (var i = 0; i < variants.length; i++) if (variants[i].feet * 12 + FIT_TOL >= rem) { lines.push({ v: variants[i], qty: 1 }); break; }
      }
      var price = 0, sheets = 0;
      lines.forEach(function (l) { price += l.v.price * l.qty; sheets += l.qty; });
      var plan = { lines: lines, cols: cols, rows: rows, w: w, h: h, rotated: o[0] !== dw, price: price, sheets: sheets, lengthIn: rows * h + (rows - 1) * GAP };
      if (!best || plan.price < best.price || (plan.price === best.price && plan.rows < best.rows)) best = plan;
    });
    return best;
  }
  function copiesNow() {
    var max = state.mode === 'design' ? MAX_COPIES : MAX_SHEETS;
    return Math.max(1, Math.min(max, parseInt(els.qty.value, 10) || 1));
  }
  function currentPlan() {
    if (state.mode === 'design' && state.design) {
      var p = packPlan(state.design.w, state.design.h, copiesNow());
      if (!p) return null;
      return p;
    }
    return null;
  }
  function planLines() {
    var plan = currentPlan();
    if (plan) return plan.lines;
    if (state.variant) return [{ v: state.variant, qty: copiesNow() }];
    return [];
  }

  function updateRows() {
    var on = {};
    planLines().forEach(function (l) { on[String(l.v.id)] = true; });
    els.table.querySelectorAll('[data-dtfu-row]').forEach(function (r) {
      r.classList.toggle('is-on', !!on[r.getAttribute('data-dtfu-row')]);
    });
  }

  function updateSummary() {
    var qty = copiesNow();
    var ok = false;
    var dsg = state.mode === 'design' && state.design;
    els.qty.max = dsg ? MAX_COPIES : MAX_SHEETS;
    if (els.qtyLabel) els.qtyLabel.textContent = dsg ? 'Copies' : 'Quantity';
    if (dsg) {
      var plan = currentPlan();
      var dTxt = round1(state.design.w) + '" x ' + round1(state.design.h) + '"';
      if (!plan) {
        els.sumSize.textContent = qty + (qty === 1 ? ' copy of ' : ' copies of ') + dTxt;
        els.sumPrice.textContent = '';
        els.sumEach.textContent = '';
        els.sumTotal.textContent = 'That is more than we can print online. Lower the number of copies or request a custom quote.';
        els.sumTotal.hidden = false;
      } else {
        ok = true;
        var sheetsTxt = plan.lines.map(function (l) { return (l.qty > 1 ? l.qty + ' x ' : '') + l.v.title; }).join(' + ');
        els.sumSize.textContent = qty + (qty === 1 ? ' copy of ' : ' copies of ') + dTxt;
        els.sumPrice.textContent = money(plan.price);
        els.sumEach.textContent = money(Math.round(plan.price / qty)) + ' per copy';
        var totalFt = 0;
        plan.lines.forEach(function (l) { totalFt += l.v.feet * l.qty; });
        els.sumTotal.textContent = 'Your print is ' + totalFt + ' ft (13" wide x ' + (totalFt * 12) + '" long). We arrange the copies for you.';
        els.sumTotal.hidden = false;
      }
    } else {
      var v = state.variant;
      if (v) {
        ok = v.available !== false;
        var one = v.title + '  (13" x ' + (v.feet * 12) + '")';
        els.sumSize.textContent = qty > 1 ? qty + ' x ' + one : one;
        els.sumPrice.textContent = money(v.price * qty);
        if (qty > 1) {
          var totalFeet = v.feet * qty;
          els.sumTotal.textContent = 'Your print is ' + totalFeet + ' ft in total (13" wide x ' + (totalFeet * 12) + '" long). Need a lot of length? A longer length costs less per foot.';
          els.sumTotal.hidden = false;
          els.sumEach.textContent = money(v.price) + ' each';
        } else {
          els.sumTotal.hidden = true;
          els.sumEach.textContent = '';
        }
      } else {
        els.sumSize.textContent = 'Upload a file or pick a size below';
        els.sumPrice.textContent = '';
        els.sumTotal.hidden = true;
        els.sumEach.textContent = '';
      }
    }
    var linkMissing = state.big && !els.link.value.trim();
    ok = ok && !!state.file && !linkMissing && !state.blocked;
    // never truly disabled: a click without a file explains what is missing instead of doing nothing
    els.add.disabled = adding;
    els.add.classList.toggle('is-off', !ok);
    state.ready = ok;
    updateRows();
  }

  function setFileUi(f) {
    els.name.textContent = f.name;
    els.size.textContent = mb(f.size);
    els.file.hidden = false;
    els.drop.hidden = true;
    els.linkRow.hidden = !state.big;
    els.thumb.innerHTML = '';
    var ext = (f.name.split('.').pop() || '').toLowerCase();
    var isPng = ext === 'png' || f.type === 'image/png';
    var px = state.detected && state.detected.px;
    if (isPng && px && px.w * px.h < 180e6 && f.size < 120 * 1048576) {
      var img = new Image();
      img.alt = '';
      img.onerror = function () { els.thumb.innerHTML = '<span class="dtfu-file__ico">PNG</span>'; };
      state.url = URL.createObjectURL(f);
      img.src = state.url;
      els.thumb.appendChild(img);
    } else {
      els.thumb.innerHTML = '<span class="dtfu-file__ico">' + (ext || 'file').toUpperCase() + '</span>';
    }
  }

  function clearFile() {
    if (state.url) { try { URL.revokeObjectURL(state.url); } catch (e) {} }
    state = { file: null, big: false, url: '', detected: null, variant: null, autoPicked: false, blocked: false, mode: 'sheet', design: null };
    els.input.value = '';
    els.link.value = '';
    els.file.hidden = true;
    els.drop.hidden = false;
    els.note.hidden = true;
    els.detect.textContent = '';
    setError('');
    updateSummary();
  }

  function showDetection(size, v) {
    var lines = [];
    var wTxt = round1(size.w) + '"', hTxt = round1(size.h) + '"';
    var msg = '<strong>Detected size:</strong> ' + wTxt + ' wide &times; ' + hTxt + ' long';
    if (state.mode === 'design') {
      msg = '<strong>This looks like a single design</strong> (' + wTxt + ' x ' + hTxt + '). Choose how many <strong>copies</strong> you want below and we fit them on a 13" sheet and price the length for you.';
    } else if (v) {
      var feetExact = size.h / 12;
      msg += '. <strong>' + v.title + '</strong> fits (' + (v.feet * 12) + '" long).';
      if (feetExact < v.feet - 0.2) lines.push('Your file is shorter than ' + v.title + ', so it is priced as ' + v.title + '. We print it at its exact size.');
    }
    els.detect.innerHTML = msg;
    if (state.mode === 'design') {
      lines.push('Tip: if you only need a few copies, or different sizes of this design, <a href="/products/dtf-transfers-by-size">order it by size</a> instead.');
    } else if (size.w < WIDTH - 0.6) lines.push('Heads up: your file is ' + wTxt + ' wide and our sheets are 13" wide. We print it at its exact size.');
    if (size.note) lines.push(size.note);
    if (state.detected && state.detected.px && size.dpi && size.dpi < 150) lines.push('This file is ' + Math.round(size.dpi) + ' dpi. For the sharpest result, export at 300 dpi.');
    els.note.innerHTML = lines.join(' ');
    els.note.hidden = !lines.length;
  }

  function handleFile(file) {
    setError('');
    els.addErr.hidden = true;
    if (!file) return;
    var ext = (file.name.split('.').pop() || '').toLowerCase();
    if (['png', 'pdf', 'ai'].indexOf(ext) < 0) {
      setError('Please upload a PNG, PDF or AI file. (' + file.name + ' is not supported.)');
      return;
    }
    clearFile();
    state.file = file;
    state.big = file.size > MAX_BYTES;
    state.blocked = false;
    var reader = ext === 'png' ? readPng(file) : readPdfLike(file);
    reader.then(function (info) {
      state.detected = info && info.kind === 'png' ? info : null;
      var size = sizeFromInfo(info);
      setFileUi(file);
      if (!size) {
        els.detect.innerHTML = '<strong>We could not read the size of this file.</strong> No problem: pick the length that matches your file in the price list below.';
        els.note.hidden = true;
        state.variant = null;
        updateSummary();
        return;
      }
      if (size.w > WIDTH + TOL) {
        state.blocked = true;
        els.detect.innerHTML = '<strong>Detected size:</strong> ' + round1(size.w) + '" &times; ' + round1(size.h) + '"';
        els.note.innerHTML = 'Both sides are wider than our 13" sheet. Please resize your file so one side is 13" or less, or <a href="/pages/contact?interest=dtf-transfers">request a custom quote</a>.';
        els.note.hidden = false;
        state.variant = null;
        updateSummary();
        return;
      }
      if (size.h < 11) {
        state.mode = 'design';
        state.design = { w: size.w, h: size.h };
        state.variant = null;
        showDetection(size, null);
        updateSummary();
        return;
      }
      var v = pickVariant(size.h);
      if (!v) {
        state.blocked = true;
        els.detect.innerHTML = '<strong>Detected size:</strong> ' + round1(size.w) + '" &times; ' + round1(size.h) + '"';
        els.note.innerHTML = 'Our longest sheet is 30 ft (360"). Split your file in two, or <a href="/pages/contact?interest=dtf-transfers">request a custom quote</a>.';
        els.note.hidden = false;
        state.variant = null;
        updateSummary();
        return;
      }
      state.variant = v;
      state.autoPicked = true;
      showDetection(size, v);
      updateSummary();
    }).catch(function () {
      setFileUi(file);
      els.detect.innerHTML = '<strong>We could not read the size of this file.</strong> Pick the length that matches your file in the price list below.';
      updateSummary();
    });
  }

  els.input.addEventListener('change', function () { handleFile(els.input.files && els.input.files[0]); });
  ['dragenter', 'dragover'].forEach(function (ev) {
    els.drop.addEventListener(ev, function (e) { e.preventDefault(); els.drop.classList.add('is-over'); });
  });
  ['dragleave', 'drop'].forEach(function (ev) {
    els.drop.addEventListener(ev, function (e) { e.preventDefault(); els.drop.classList.remove('is-over'); });
  });
  els.drop.addEventListener('drop', function (e) {
    var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (f) handleFile(f);
  });
  els.remove.addEventListener('click', function () { clearFile(); try { els.input.click(); } catch (e) {} });
  els.link.addEventListener('input', updateSummary);

  // choose a length by hand from the price list
  function pickRow(row) {
    var id = row.getAttribute('data-dtfu-row');
    var v = variants.filter(function (x) { return String(x.id) === id; })[0];
    if (!v) return;
    state.variant = v;
    state.mode = 'sheet';
    state.blocked = false;
    state.autoPicked = false;
    updateSummary();
    var card = q('[data-dtfu-sum]');
    if (card && card.scrollIntoView && !state.file) { try { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
  }
  els.table.querySelectorAll('[data-dtfu-row]').forEach(function (row) {
    row.addEventListener('click', function (e) {
      if (e.target.closest('[data-dtfu-tpl]')) return;
      pickRow(row);
    });
    row.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('[data-dtfu-tpl]')) { e.preventDefault(); pickRow(row); }
    });
  });

  els.qty.addEventListener('change', function () { els.qty.value = copiesNow(); updateSummary(); });
  els.minus.addEventListener('click', function () { els.qty.value = Math.max(1, copiesNow() - 1); updateSummary(); });
  els.plus.addEventListener('click', function () { var max = state.mode === 'design' ? MAX_COPIES : MAX_SHEETS; els.qty.value = Math.min(max, copiesNow() + 1); updateSummary(); });

  // ---------- add to cart ----------
  var adding = false;
  els.add.addEventListener('click', function () {
    var lines = planLines();
    if (adding) return;
    if (!state.ready) {
      var msg = !state.file ? 'Upload your print-ready file first, then add it to your cart.' : state.blocked ? 'Please fix the file size issue above first.' : (state.big && !els.link.value.trim()) ? 'Paste the download link for your large file first.' : 'Choose a size first.';
      els.addErr.textContent = msg;
      els.addErr.hidden = false;
      var target = !state.file ? els.drop : els.file;
      if (target && target.scrollIntoView) { try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
      if (!state.file) { els.drop.classList.add('is-over'); setTimeout(function () { els.drop.classList.remove('is-over'); }, 1400); }
      return;
    }
    if (!lines.length || !state.file) return;
    adding = true;
    els.add.classList.add('is-loading');
    els.add.disabled = true;
    els.addErr.hidden = true;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var plan = currentPlan();
    var copies = copiesNow();
    var layoutTxt = plan ? copies + ' copies of ' + round1(state.design.w) + '" x ' + round1(state.design.h) + '", ' + plan.cols + (plan.cols === 1 ? ' design' : ' designs') + ' per row x ' + plan.rows + (plan.rows === 1 ? ' row' : ' rows') + (plan.rotated ? ' (rotated)' : '') : '';
    var chain = Promise.resolve(null);
    lines.forEach(function (ln, i) {
      var isLast = i === lines.length - 1;
      chain = chain.then(function () {
        var fd = new FormData();
        fd.append('id', ln.v.id);
        fd.append('quantity', ln.qty);
        fd.append('properties[Size]', '13" x ' + (ln.v.feet * 12) + '" (' + ln.v.title + ')');
        if (plan) {
          fd.append('properties[_Layout]', layoutTxt + '');
          fd.append('properties[_Copies]', String(copies));
          fd.append('properties[_Design Size]', round1(state.design.w) + ' x ' + round1(state.design.h) + ' in');
        }
        fd.append('properties[_Artwork Name]', state.file.name);
        fd.append('properties[_File Confirmation]', 'Customer confirmed the file is correct and final by adding to cart on ' + new Date().toISOString());
        if (state.detected && state.detected.px) fd.append('properties[_Detected Pixels]', state.detected.px.w + ' x ' + state.detected.px.h);
        if (state.big) fd.append('properties[Artwork Link]', els.link.value.trim());
        else fd.append('properties[_Artwork File]', state.file, state.file.name);
        if (isLast && cart && cart.getSectionsToRender) {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }
        return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (out) {
            if (!out.ok || out.json.status) throw new Error(out.json.description || out.json.message || 'Could not add this to your cart.');
            return out.json;
          });
      });
    });
    chain.then(function (last) {
      adding = false;
      els.add.classList.remove('is-loading');
      updateSummary();
      if (cart && cart.renderContents && last && last.sections) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(last);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    }).catch(function (err) {
      adding = false;
      els.add.classList.remove('is-loading');
      updateSummary();
      els.addErr.textContent = err.message || 'Something went wrong. Please try again.';
      els.addErr.hidden = false;
    });
  });

  updateSummary();
})();
